import { Box, Button, CircularProgress, Container, Grid, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getDownloadAPK } from "store/app/download-APK/actions";
import { ErrorAlert, SuccessAlert } from "ui-component/custom-components/alertMessage";
import Logo from "ui-component/Logo";
import headerBackground from 'assets/images/landing/bg-header.jpg';
import { gridSpacing } from 'store/constant';
import mailImg from 'assets/images/landing/widget-android.svg';
import MainCard from "ui-component/cards/MainCard";
import AuthFooter from "ui-component/cards/AuthFooter";

const DownloadAPK = (props) => {

    const { errorMessage, isPending, downloadAPKSuccess } = props;
    const { homePage } = window.__ENV || {};

    useEffect(() => {
        props.getAPKFile();
    }, []);

    const handledownload = (e) => {
        e.preventDefault();
        props.getAPKFile();

    }
    return (
        <>
            <Box
                sx={{
                    backgroundImage: `url(${headerBackground})`,
                    backgroundSize: { lg: '100% 500px', md: '100% 500px', xs: "100% 400px" },
                    backgroundAttachment: 'fixed',
                    backgroundRepeat: 'no-repeat',
                    textAlign: 'center',
                    pt: { xs: 0, md: 3.75 }
                }}
            >  <Grid item sx={{ paddingTop: "5px", position: "absolute", top: "0px", width: "100vw", bgcolor: "white" }}>
                    <Link to={homePage} aria-label="theme-logo">
                        <Logo />
                    </Link>
                </Grid>
                <Container>
                    <Grid container justifyContent="center" spacing={gridSpacing}>
                        <Grid item sm={10} md={7} sx={{ mt: { md: 12.5, xs: 2.5 }, mb: { md: 6.5, xs: 2.5 } }}>
                            <Grid container spacing={gridSpacing}>
                                <Grid item xs={12}>
                                    <Typography
                                        variant="h1"
                                        color="white"
                                        sx={{
                                            fontSize: { xs: '1.8125rem', md: '3.5rem' },
                                            fontWeight: 900,
                                            lineHeight: 1.4,
                                            mt: { xs: 10, md: 'auto' }
                                        }}
                                    >
                                        Download Kemin APK
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography
                                        variant="h4"
                                        sx={{ fontWeight: 400, lineHeight: 1.4, my: { xs: 0, md: 'auto' }, mx: { xs: 6.5, md: 'auto' } }}
                                        color="white"
                                    >
                                        Thank you for visitting our page.
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sx={{ position: 'relative', display: { xs: 'none', lg: 'block' } }}>
                            <img
                                src={mailImg}
                                alt="APK"
                                style={{
                                    marginBottom: -0.625,
                                    position: 'absolute',
                                    bottom: -10,
                                    right: '0',
                                    width: 200,
                                    maxWidth: '100%',
                                    animation: '5s wings ease-in-out infinite'
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                            <MainCard sx={{ textAlign: 'left', width: { lg: "60%", md: "70%", sm: "100%", xs: "100%" } }} elevation={4} border={false} boxShadow shadow={4}>
                                <Grid item xs={12} sx={{ paddingTop: "5px", paddingBottom: "5px" }}>
                                    {errorMessage && <ErrorAlert type={'error'} content={errorMessage} />}
                                    {downloadAPKSuccess && <SuccessAlert type={'success'} content={"Your APK file successfully downloaded."} />}
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography sx={{ textAlign: "left", color: "grey" }}>
                                        The latest version of the APK will download automatically when the page loads.
                                        If the download does not start, please click the button below.
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", mt: 2, mb: 2 }}>
                                    <Button variant="contained"
                                        disabled={isPending}
                                        onClick={handledownload}
                                    >
                                        {isPending ?
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                <CircularProgress size={'20px'} color='inherit' />
                                                Downloading...
                                            </div>
                                            : <> Download APK</>
                                        }

                                    </Button>
                                </Grid>
                            </MainCard>
                        </Grid>
                    </Grid>
                </Container>
                <Grid item xs={12} sx={{ m: 3, mt: 4 }}>
                    <Grid container justifyContent="center">
                        <AuthFooter />
                    </Grid>
                </Grid>
            </Box>
        </>
    )
}

const mapStateToProps = (state) => ({
    isPending: state.downloadAPK.isDownloadAPKPending,
    downloadAPKSuccess: state.downloadAPK.downloadAPKSuccess,
    errorMessage: state.downloadAPK.downloadAPKErrorMessage,
})
const mapDispatchToProps = (dispatch) => ({
    getAPKFile: () => dispatch(getDownloadAPK()),
})

export default connect(mapStateToProps, mapDispatchToProps)(DownloadAPK);